// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"wr-z","imageAndVideoCount":"xr-z","imageAndVideoContainer":"yr-z","viewAllReviews":"zr-z"};